export const MOCK_WORKFLOW_LIST_RESPONSE = {
  count: 3,
  total_pages: 1,
  current_page: 1,
  results: [
    {
      id: 'mock-wf-1',
      name: 'Full Vulnerability Scan',
      name_fa: 'اسکن آسیب‌پذیری کامل',
      description: 'Runs a comprehensive vulnerability scan on all assets.',
      description_fa: 'اسکن جامع آسیب‌پذیری روی تمام دارایی‌ها.',
      icon: 'shield',
      created: '2024-01-10T10:00:00Z',
      created_jalali: '۱۴۰۲/۱۰/۲۰',
      is_draft: false,
      is_public: false,
      tags: ['vulnerability', 'full'],
      tags_fa: ['آسیب‌پذیری', 'کامل'],
    },
    {
      id: 'mock-wf-2',
      name: 'Port Discovery',
      name_fa: 'کشف پورت',
      description: 'Discovers open ports across your attack surface.',
      description_fa: 'پورت‌های باز در سطح حمله شما را کشف می‌کند.',
      icon: 'ethernet',
      created: '2024-01-08T09:30:00Z',
      created_jalali: '۱۴۰۲/۱۰/۱۸',
      is_draft: false,
      is_public: false,
      tags: ['ports', 'discovery'],
      tags_fa: ['پورت', 'کشف'],
    },
    {
      id: 'mock-wf-3',
      name: 'SSL Certificate Audit',
      name_fa: 'بررسی گواهی SSL',
      description: 'Audits SSL/TLS certificates for expiry and misconfigurations.',
      description_fa: 'گواهی‌های SSL/TLS را از نظر انقضا و پیکربندی نادرست بررسی می‌کند.',
      icon: 'lock',
      created: '2024-01-05T14:00:00Z',
      created_jalali: '۱۴۰۲/۱۰/۱۵',
      is_draft: true,
      is_public: false,
      tags: ['ssl', 'audit'],
      tags_fa: ['SSL', 'بررسی'],
    },
  ],
}

export const MOCK_WORKFLOW_LIST_FILTER_OPTIONS = {
  tags: [
    { name: 'vulnerability' },
    { name: 'ports' },
    { name: 'ssl' },
    { name: 'discovery' },
    { name: 'audit' },
    { name: 'full' },
  ],
}
